import React from 'react'
import hero from '../images/illustration-hero.svg'
import iconMusic from '../images/icon-music.svg'

function Card() {
    return (
        <>
            <div className='bg-DesktopPattern bg-auto h-screen w-screen  bg-50% bg-auto bg-no-repeat flex flex-col justify-center items-center  bg-VeryPaleBlue sm:bg-DesktopPattern bg-auto'>
                <div className='bg-white w-20 bg-white rounded-2xl w-96 shadow-lg'>
                    <div>
                        <img src={hero} alt="hero" className='rounded-tl-2xl rounded-tr-2xl h-40 w-full' />
                    </div>
                    <div className='flex flex-col justify-center items-center w-full px-6 py-9 gap-6'>
                        <h1 className='font-black font-redhat text-xl'>Order Summary</h1>
                        <p className='text-center font-redhat'>You can now listen to millions of songs, audiobooks, and podcasts on any device anywhere you like</p>
                        <div className='flex items-center w-full justify-between rounded-2xl p-4 bg-VeryPaleBlue'>
                            <div className='flex gap-5'>
                                <img src={iconMusic} alt="music-icon" />
                                <h2 className='font-redhat text-base'>Annual Plan <br />$59.99/year</h2>
                            </div>
                            <a href="/" className='underline font-bold font-redhat text-DarkBlue text-base hover:delay-300 hover:text-DesaturatedBlue hover:no-underline'>change</a>
                        </div>
                        <div className='bg-BrightBlue px-16 py-5 text-white font-bold font-redhat rounded-xl shadow-indigo-500/40 shadow-lg ease-in-out duration-300 hover:cursor-pointer hover:bg-DesaturatedBlue'>
                            Proceed to Payment
                        </div>
                        <a href="/" className='font-bold font-redhat text-DesaturatedBlue duration-300 hover:text-DarkBlue'>Cancel Order</a>
                    </div>

                </div>
            </div>

        </>
    )
}

export default Card